<script lang="ts">
  export let title;
  import { toast } from '@zerodevx/svelte-toast'

  let email = "";
  let newsLetterError = "";

  async function handleSubmit(event) {
    const payload = {
      email
    };
    console.log(payload);
    try {
      const result = await fetch(
        `${__myapp.env.CWS_API_URL}/newsletterRegistration`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            ...payload
          })
        }
      );

      console.log(result);

      if (!result.ok) {
        newsLetterError = result.statusText;

        return;
      }
      toast.push("You've been subscribed!")
      signUpSuccess = true;
    } catch (e) {
      console.error(`Could not sign up for newsletter ${e}`);
    }
  }
</script>

<style>
  input {
    background: transparent;
    border: none;
    color: #ae8aeb;
    text-align: left;
    width: 200px;
  }

  input:focus {
    color: #000;
  }

  input::placeholder {
    color: #b3b3b3;
  }

  .fa-arrow-right {
    color: #b3b3b3;
  }

  .navbar-transparent input:focus {
    color: #fff;
  }
  
  @media all and (max-width: 991px) {
    .fa-arrow-right {
      color: #000;
    }

    input {
      margin-left: 25px;
    }

    input:focus {
      color: #000 !important;
    }
  }

</style>

<div>
  <nav
    class="navbar navbar-transparent navbar-color-on-scroll fixed-top
    navbar-expand-lg"
    color-on-scroll="100"
    id="sectionsNav">
    <div class="container">
      <div class="navbar-translate text-info">
        <a class="navbar-brand" href="/">{title}</a>
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          aria-expanded="false"
          aria-label="Toggle navigation">
          <span class="sr-only">Toggle navigation</span>
          <span class="navbar-toggler-icon" />
          <span class="navbar-toggler-icon" />
          <span class="navbar-toggler-icon" />
        </button>
      </div>
      <div class="collapse navbar-collapse">
        <ul class="navbar-nav ml-auto">
          <li class="dropdown nav-item">
            <a href="#" class="dropdown-toggle nav-link" data-toggle="dropdown">
              <i class="material-icons">apps</i>
              Customers
            </a>
            <div class="dropdown-menu dropdown-with-icons">
              <a href="/case-study/vul" class="dropdown-item">
                <i class="material-icons">local_gas_station</i>
                VuL
              </a>
              <a href="/case-study/gmgt" class="dropdown-item">
                <i class="material-icons">music_note</i>
                GMGT
              </a>
            </div>
          </li>
          <li class="nav-item">
            <a href="/estimator" class="nav-link">
              <i class="material-icons" style="color: rgb(180,240,100)">
                monetization_on
              </i>
              Cost estimator
            </a>
          </li>
          <li class="nav-item">
            <div>
              <input
                placeholder="Sign up for our newsletter"
                bind:value={email} />
              <i
                class="fa fa-arrow-right fa-xs"
                style="cursor: pointer;"
                on:click|preventDefault={handleSubmit} />
            </div>
          </li>
<!--          <li class="nav-item">-->
<!--            <a-->
<!--              class="nav-link"-->
<!--              rel="tooltip"-->
<!--              title=""-->
<!--              data-placement="bottom"-->
<!--              href="https://twitter.com/CodeWorldSol"-->
<!--              target="_blank"-->
<!--              data-original-title="Follow us on Twitter">-->
<!--              <i class="fa fa-twitter" />-->
<!--            </a>-->
<!--          </li>-->
          <li class="nav-item">
            <a
              class="nav-link"
              rel="tooltip"
              title=""
              data-placement="bottom"
              href="https://www.facebook.com/CodeWorldSol/"
              target="_blank"
              data-original-title="Like us on Facebook">
              <i class="fa fa-facebook-f"></i>Facebook
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              rel="tooltip"
              title=""
              data-placement="bottom"
              href="https://www.instagram.com/code.world2020/"
              target="_blank"
              data-original-title="Follow us on Instagram">
              <i class="fa fa-instagram"></i>Instagram
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</div>
